var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNairaCircularDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#5A5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66666 15V5.87667C5.66661 5.68277 5.73095 5.49435 5.8496 5.34099C5.96824 5.18763 6.13447 5.07802 6.32216 5.02938C6.50986 4.98074 6.70839 4.99582 6.88659 5.07226C7.06478 5.14869 7.21254 5.28215 7.30666 5.45167L12.36 14.5483C12.4541 14.7179 12.6019 14.8513 12.7801 14.9277C12.9583 15.0042 13.1568 15.0193 13.3445 14.9706C13.5322 14.922 13.6984 14.8124 13.8171 14.659C13.9357 14.5057 14 14.3172 14 14.1233V5M4 8.33333H15.6667M4 11.6667H15.6667",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaCircularDark);
export default __webpack_public_path__ + "static/media/nairaCircularDark.dbc0d0ee7e90397a9a4acee6a2ea5def.svg";
export { ForwardRef as ReactComponent };